module.exports = __webpack_public_path__ + "f593a98b7f187a63d0f6f8b1ad8ead01.svg";